import { Base64 } from 'js-base64';
import Container from './container';

const tokenStorageKey = 'token';
const fetchHeaderTokenKey = 'x-mn-token';

/**
 *  保存token 保存成功后会返回用户特征,
 *  失败会返回空，失败报错格式错误，过期等
*/
const saveToken = (token)=>{
    return valiflyToken(token,(successToken)=>{
        Container.localSave(tokenStorageKey,successToken);
    });
}

/**
 * 清除当前token
 * 
*/
const clearToken = ()=>{
    Container.localRemove(tokenStorageKey);
}

/**
 *  获取 token 会先验证一下token
 *  如果验证失败会返回空，失败报错格式错误，过期等
*/
const getToken = ()=>{
    let localToken = Container.localGet(tokenStorageKey);
    return valiflyToken(localToken,undefined,()=>{
        clearToken();
    }) && localToken;
}

/**
 * 检查是否登录
 * 
*/
const loginUser = ()=>{
    let localToken = Container.localGet(tokenStorageKey);
    return valiflyToken(localToken,undefined,()=>{
        clearToken();
    });
}

const localUserId = ()=>{
    let userFeature = loginUser();
    return userFeature && userFeature.payload.userKey;
}

/**
 * 校验token
*/
const valiflyToken = (token,success,error)=>{
    let userFeature = undefined;
    if(token){
        let jwtMatch = token.match(/[^\.]*\.([^\.]*)\.[^\.]*/);
        if(jwtMatch){
            var userInfoJson = Base64.decode(jwtMatch[1]);
            try{
                userFeature = JSON.parse(userInfoJson);
                //console.log(userFeature);
            }catch(e){
                //这里只会解析userInfo时出错
                console.error(e);
            }
        }
    }

    //如果过期了也不让取出来
    //if(userFeature){
    if(userFeature && (userFeature.exp-new Date().getTime()>0)){
        success && success(token,userFeature);
    }else{
        error && error();
        userFeature = undefined;
    }
    return userFeature;
}

const discoverToken = () => {
    console.log('try find token ....');
    let token = siteInit.cutParamCommand('token');
    if(token){
        console.log('find token :%s',token);
        let ret = saveToken(token);
        console.log(ret);
    }
}

/**
 * 应该用一个语法限制 headers输入的类型
 * 
*/
const fillLocalToken = (headers)=>{
        let localToken = getToken();
        if(localToken) headers['x-mn-token'] = localToken;
}

/**
 * 应该用一个语法限制 headers输入的类型
 * 
*/
const handResponseToken = (headers) =>{
    if (headers['x-change-token']) saveToken(headers['x-change-token']);
    if (headers['x-clear-token']) clearToken();

}


export default {saveToken,clearToken,getToken,loginUser,localUserId,discoverToken,handResponseToken,fillLocalToken};


// WEBPACK FOOTER //
// ./src/utils/auth.js